import { ref } from 'vue'

export function useScrollbarLock() {
  const scrollTop = ref(0)

  const lockScrollbar = () => {
    const isSingleLockerOnPage = document.querySelectorAll('.body-scrollbar-locker').length < 2
    if (!isSingleLockerOnPage) return
    const currentScrollTop = window.scrollY
    document.body.classList.add('lock-scrollbar')
    scrollTop.value = currentScrollTop
    document.body.style.top = `-${currentScrollTop}px`
  }

  const unlockScrollbar = () => {
    const isSingleLockerOnPage = document.querySelectorAll('.body-scrollbar-locker').length < 2
    if (!isSingleLockerOnPage) return
    document.body.classList.remove('lock-scrollbar')
    document.body.style.top = ''
    window.scrollTo({
      top: scrollTop.value,
      behavior: 'instant',
    })
  }

  return {
    scrollTop,
    lockScrollbar,
    unlockScrollbar,
  }
}
